import { WprFramework } from './WprFramework';

/**
 * WPRフレームワーク基本クラス
 */
export abstract class WprBaseObject {
	// private 変数  ------------------------------------------------------------
	private m_Framework: WprFramework		= null;			// フレームワーク
	private m_ObjectName: string			= null;			// オブジェクト名
	// --------------------------------------------------------------------------

	// プロパティ  ---------------------------------------------------------------
	/** フレームワーク */
	protected get FW(): WprFramework	{
		if (this.m_Framework == null)
			this.m_Framework = WprFramework.getInstance();
		return this.m_Framework;
	}
	/** オブジェクト名 */
	public get objectName(): string	{ return this.m_ObjectName;	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor(objectName?: string) {
		if (objectName)
			this.m_ObjectName = objectName;
		else
			this.m_ObjectName = 'NoName';
	}
	// --------------------------------------------------------------------------

	// public メソッド	---------------------------------------------------------
	/**
	 * でバックログ出力
	 * @param msg メッセージ
	 */
	public addDebugLog(msg: string): void {
		this.FW.error.addDebugLog(this.m_ObjectName, msg);
	}

	/**
	 * 情報ログ出力
	 * @param msg メッセージ
	 */
	public addInfoLog(msg: string): void {
		this.FW.error.addInfoLog(this.m_ObjectName, msg);
	}

	/**
	 * 警告ログ出力
	 * @param msg メッセージ
	 */
	public addWarningLog(msg: string): void {
		this.FW.error.addWarningLog(this.m_ObjectName, msg);
	}

	/**
	 * エラーログ出力
	 * @param msg メッセージ
	 * @param ex 例外情報
	 */
	public addErrorLog(msg: string, ex?: Error): void {
		this.FW.error.addErrorLog(this.m_ObjectName, msg, ex);
	}
	// --------------------------------------------------------------------------
}
